import React, { ReactNode } from "react";
import styles from "./container-panel.module.scss";

interface ContainerPanelPropTypes {
  children: ReactNode;
}

const cssClassName = "container-panel";

export const ContainerPanel = ({ children }: ContainerPanelPropTypes) => {
  return <div className={styles[cssClassName]}>{children}</div>;
};
